import "core-js/modules/es.object.assign.js";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import './ImageDisplay.css';
import { HomeIcon, ImageLoadingIcon, SearchPlusIcon, PlayIcon } from '@anewgo/icons';

var ImageDisplay = function ImageDisplay(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      flip = _ref.flip,
      objectFit = _ref.objectFit,
      style = _ref.style,
      imageGallery = _ref.imageGallery,
      isVideoPreview = _ref.isVideoPreview;
  var mountedRef = useRef();
  var contentRef = useRef();

  var _useState = useState(true),
      loading = _useState[0],
      setLoading = _useState[1];

  useEffect(function () {
    if (!src || contentRef.current) {
      if (!src) {
        setLoading(false);
      }

      return;
    }

    setLoading(true);
    contentRef.current = new Image();

    contentRef.current.onload = function () {
      if (mountedRef.current) {
        setLoading(false);
      }
    };

    contentRef.current.onerror = function (e) {
      if (mountedRef.current) {
        console.log('encountered error loading image', e);
      }
    };

    contentRef.current.src = src;
  });
  useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  });
  var localStyles = {
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      position: 'relative'
    },
    img: {
      width: '100%',
      objectFit: objectFit
    },
    flip: {
      transform: 'scaleX(-1)'
    },
    hoverLayer: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(0,0,0,.5)',
      zIndex: 2
    },
    searchIconStyle: {
      color: '#fff',
      width: 'auto',
      height: '20%'
    }
  };
  var imageStyle = flip ? Object.assign({}, localStyles.img, localStyles.flip, style) : Object.assign({}, localStyles.img, style);
  return /*#__PURE__*/React.createElement("div", {
    style: localStyles.root,
    className: "image-display " + (imageGallery ? 'is-gallery' : '')
  }, loading && !imageGallery && /*#__PURE__*/React.createElement("div", {
    className: "loading-item"
  }, /*#__PURE__*/React.createElement(HomeIcon, {
    fill: '#CDCDCD'
  })), loading && imageGallery && /*#__PURE__*/React.createElement("div", {
    className: "loading-item"
  }, /*#__PURE__*/React.createElement(ImageLoadingIcon, {
    fill: '#CDCDCD'
  })), !src && !loading && /*#__PURE__*/React.createElement("div", {
    className: "not-loading-item"
  }, /*#__PURE__*/React.createElement(HomeIcon, {
    fill: '#CDCDCD'
  })), src && !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    style: imageStyle,
    className: "img",
    src: src,
    alt: alt
  }), imageGallery && /*#__PURE__*/React.createElement("div", {
    style: localStyles.hoverLayer,
    className: "imageOverflow"
  }, isVideoPreview ? /*#__PURE__*/React.createElement(PlayIcon, {
    style: localStyles.searchIconStyle
  }) : /*#__PURE__*/React.createElement(SearchPlusIcon, {
    style: localStyles.searchIconStyle
  }))));
};

ImageDisplay.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  flip: PropTypes.bool,
  objectFit: PropTypes.string,
  style: PropTypes.object,
  imageGallery: PropTypes.bool,
  isVideoPreview: PropTypes.bool
};
ImageDisplay.defaultProps = {
  alt: '',
  objectFit: 'contain',
  flip: false,
  src: null,
  imageGallery: false,
  style: {},
  isVideoPreview: false
};
export default ImageDisplay;